<template>
  <div>
          <h1 class="TopicHead">TEXT</h1>
          <h2 class="Topic">TEXT</h2>
          <h2 class="Topic">TEXT</h2>
          <h2 class="Topic">TEXT</h2>
        </div>
</template>

<script>
export default {
components: {  
    
},
        name: 'TextComponent',
        data () {
            return {

            }
        },

        computed: {

        },

        watch: {

        },

        mounted () {
//
        },

        created () {

        },

        beforeDestroy () {

        },
        methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },

        }
    }
</script>

<style>

</style>